import { graphql, useFragment } from "react-relay";
import { Schema, APPROVAL_FILTER } from "./schema";
import { FormattedMessage, defineMessages } from "react-intl";
import { useValibotFormContext } from "@/utils/validation";
import {
  Select,
  SelectItem,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectNoneItem,
} from "@/kit/ui/select";
import { FormField, FormControl, FormItem, FormMessage } from "@/kit/ui/form";
import { FiltersForCompetitionApprovalsFragment$key } from "./__generated__/FiltersForCompetitionApprovalsFragment.graphql";

const Fragment = graphql`
  fragment FiltersForCompetitionApprovalsFragment on Competition {
    viewerCanApprove: viewerCan(action: CREATE_PROJECT_VERSION_APPROVAL)
  }
`;

interface Props {
  competition: FiltersForCompetitionApprovalsFragment$key;
}

const LABELS = defineMessages({
  AWAITING_ANY: { id: "AWAITING_ANY", defaultMessage: "Awaiting any review" },
  AWAITING_MINE: { id: "AWAITING_MINE", defaultMessage: "Awaiting my review" },
  HAS_ANY: { id: "HAS_ANY", defaultMessage: "Has any review" },
  HAS_MINE: { id: "HAS_MINE", defaultMessage: "Has my review" },
});

export const Filters = ({ competition: competitionFragment }: Props) => {
  const competition = useFragment(Fragment, competitionFragment);
  const form = useValibotFormContext<Schema>();
  return (
    <FormField
      control={form.control}
      name="approvalFilter"
      render={({ field }) => (
        <FormItem>
          <FormControl>
            <Select {...field}>
              <SelectTrigger className="w-auto">
                <SelectValue placeholder="All submissions" />
              </SelectTrigger>
              <SelectContent>
                <SelectNoneItem>
                  <FormattedMessage defaultMessage="All submissions" />
                </SelectNoneItem>
                {APPROVAL_FILTER.filter((item) => {
                  switch (item) {
                    case "AWAITING_MINE":
                    case "HAS_MINE":
                      return competition.viewerCanApprove;
                    case "AWAITING_ANY":
                    case "HAS_ANY":
                      return true;
                  }
                }).map((item) => (
                  <SelectItem key={item} value={item}>
                    <FormattedMessage {...LABELS[item]} />
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
